import React, { useState, useEffect } from 'react'
import styles from './AlertModal.module.css'

/**
 * 단순 메시지를 표시하는 모달
 * @param {boolean} isOpen - 모달 열림/닫힘 상태
 * @param {function} onClose - 모달 닫기 콜백
 * @param {string} message - 표시할 메시지
 * @param {string} title - 모달 제목 (선택사항)
 */
const AlertModal = ({ isOpen, onClose, message, title }) => {
  const [topPosition, setTopPosition] = useState('50%')

  useEffect(() => {
    if (isOpen) {
      const scrollY = window.pageYOffset || window.scrollY || document.documentElement.scrollTop
      const viewportHeight = window.innerHeight
      const calculatedTop = scrollY + viewportHeight / 2
      setTopPosition(`${calculatedTop}px`)
    }
  }, [isOpen])

  if (!isOpen) return null

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div
        className={styles.modalContent}
        style={{ top: topPosition }}
        onClick={(e) => e.stopPropagation()}
      >
        {title && (
          <div className={styles.header}>
            <h2>{title}</h2>
          </div>
        )}
        <div className={styles.message}>
          <p>{message}</p>
        </div>
        <div className={styles.actions}>
          <button className={styles.confirmButton} onClick={onClose}>
            확인
          </button>
        </div>
      </div>
    </div>
  )
}

export default AlertModal
